import React, { useEffect, useState } from "react";
import {  Col, Modal, Row } from "react-bootstrap";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import LoginModal from "./LoginModal";
import { LoadToast, isEmpty, updateToast, validation } from "../lib/common";
import * as User from "../Axios/user.axios";
import { useNavigate } from "react-router";


const VerifyOtp = ({ showVerifyotp, handleForgotEmailClose,handleVerifyotpClose,UserEmail }) => {
  const [loginShow, setLoginShow] = useState(false);
  const initial = {
    OTP: "",
    Email:UserEmail

  };
  const [formdata, setFormdata] = useState(initial);
  const [err, setErr] = useState({});
  
  const handleLoginClose = () => setLoginShow(false);
  const navigate = useNavigate();



  const handleLoginShow = () => {
    handleVerifyotpClose();
    handleForgotEmailClose();
  };



  const onchange = (e) => {
    const { id, value } = e.target;
    setFormdata({ ...formdata, ...{ [id]: value } });
  };
  const submit = async () => {
    const id = LoadToast();
    let err = await validation(Object.keys(initial), formdata);
    
    if (Object.keys(err)?.length > 0) {
      updateToast(id, "fix");
      setErr(err);
      return;
    }
    setErr({});
    
    var { success, msg } = await User.VerifyOTP(formdata);
    updateToast(
      id,
      msg,
      success
    );
    if (!isEmpty(success)) {
      // history.push("/dashboard");
    } else setErr(err);
  };
  return (
    <div>
        <LoginModal loginShow={loginShow} handleLoginClose={handleLoginClose} />
    
      <Modal
        show={showVerifyotp}
        onHide={handleForgotEmailClose}
        centered
        size="lg"
        className="custom_modal signup_modal"
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <Row className="mx-auto sgn_row">
            <Col xs={12} xl={6} className="p-0">
              <div className="login_mdl_right">
                <h4 className="modal_title">Verify  OTP</h4>
                <p className="thm_labl mt-4 mb-2">OTP</p>
                <input
                  type="number"
                  placeholder="OTP"
                  className="cred_input mb-2"
                  id="OTP"
                  value={formdata.OTP}
                  onChange={onchange}
                />{" "}
                   {err?.OTP && (
                      <p className="text-left err_msg_txt">{err?.OTP}</p>
                    )}
                <button className="themeButton my-4" onClick={()=>submit()}>Continue</button>
                <p className="sgn_nav_p">
                  By clicking <span className="sng_rgst_btn">'Register'</span>,
                  I agree to the{" "}
                  <span className="sgn_term_btn" onClick={()=>navigate("/cms?content=termsandconditions")}>Terms of Use</span> and 
 and 
 <span className="sgn_term_btn" onClick={()=>navigate("/cms?content=privacypolicy")}>Privacy Policy</span>
                </p>
              </div>
            </Col>{" "}
            <Col
              xs={12}
              xl={6}
              className="p-0 d-flex align-items-center justify-content-center"
            >
              {/* <div className="login_mdl_right no_border">
                <div className="d-flex flex-column align-items-center justify-content-center  sign_optn">
                  <p>Login With Smart way</p>
                  <div>
                    <button>
                      <img src={Image.eth} alt="eth" className="img-fluid" />
                    </button>{" "}
                    <button>
                      <img
                        src={Image.google}
                        alt="google"
                        className="img-fluid"
                      />
                    </button>{" "}
                    <button>
                      <img
                        src={Image.message}
                        alt="message"
                        className="img-fluid"
                      />
                    </button>{" "}
                    <button>
                      <img
                        src={Image.facebook}
                        alt="facebook"
                        className="img-fluid"
                      />
                    </button>{" "}
                  </div>
                </div>
              </div> */}
            </Col>
          </Row>
{/* 
          <div className="sgn_bot_sec">
            <p className="mb-0">
              Back to login?{" "}
              <span className="sgn_term_btn" onClick={() => handleLoginShow()}>
                {" "}
                LOGIN
              </span>
            </p>
          </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerifyOtp;
